import { render, staticRenderFns } from "./DegreesCreate.vue?vue&type=template&id=44eed933"
import script from "./DegreesCreate.vue?vue&type=script&lang=js"
export * from "./DegreesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports